export const rooms = [
  {
    id: '1',
    name: 'Phòng Studio Cao Cấp A1',
    type: 'studio',
    price: 3500000,
    area: 25,
    floor: 3,
    status: 'available',
    rating: 4.9,
    reviewCount: 42,
    images: [
      'https://readdy.ai/api/search-image?query=modern%20studio%20apartment%20interior%20with%20minimalist%20design%2C%20white%20walls%2C%20wooden%20floor%2C%20large%20window%2C%20cozy%20bed%2C%20clean%20aesthetic%2C%20bright%20natural%20light%2C%20Vietnam%20apartment&width=800&height=600&seq=r1a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=modern%20studio%20apartment%20bathroom%20with%20clean%20white%20tiles%2C%20shower%2C%20good%20lighting%2C%20minimalist%20design%2C%20Vietnam%20rental%20room&width=800&height=600&seq=r1b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=studio%20apartment%20kitchen%20area%20with%20compact%20design%2C%20modern%20appliances%2C%20clean%20countertop%2C%20bright%20lighting&width=800&height=600&seq=r1c&orientation=landscape',
    ],
    amenities: ['Wifi 100Mbps', 'Điều hòa', 'Tủ lạnh', 'Máy giặt', 'Bếp từ', 'Ban công'],
    description: 'Phòng studio hiện đại, đầy đủ nội thất cao cấp. View đẹp, thoáng mát, an ninh 24/7.',
    featured: true,
  },
  {
    id: '2',
    name: 'Phòng 1 Phòng Ngủ B2',
    type: '1bedroom',
    price: 5000000,
    area: 35,
    floor: 5,
    status: 'available',
    rating: 4.8,
    reviewCount: 38,
    images: [
      'https://readdy.ai/api/search-image?query=one%20bedroom%20apartment%20interior%20modern%20design%2C%20separate%20bedroom%20with%20queen%20bed%2C%20living%20room%2C%20clean%20white%20walls%2C%20wooden%20furniture%2C%20bright%20natural%20light&width=800&height=600&seq=r2a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=modern%20apartment%20living%20room%20with%20sofa%2C%20TV%2C%20minimalist%20decor%2C%20bright%20lighting%2C%20clean%20aesthetic&width=800&height=600&seq=r2b&orientation=landscape',
    ],
    amenities: ['Wifi 100Mbps', 'Điều hòa', 'Tủ lạnh', 'Máy giặt', 'Bếp từ', 'Phòng tắm riêng'],
    description: 'Căn hộ 1 phòng ngủ rộng rãi, phòng khách riêng biệt, đầy đủ tiện nghi.',
    featured: true,
  },
  {
    id: '3',
    name: 'Phòng Deluxe C3',
    type: 'deluxe',
    price: 4200000,
    area: 30,
    floor: 7,
    status: 'available',
    rating: 4.7,
    reviewCount: 55,
    images: [
      'https://readdy.ai/api/search-image?query=deluxe%20hotel%20room%20style%20apartment%2C%20premium%20interior%20design%2C%20king%20size%20bed%2C%20elegant%20decor%2C%20city%20view%20window%2C%20luxury%20feel%2C%20Vietnam&width=800&height=600&seq=r3a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=luxury%20apartment%20bathroom%20with%20bathtub%2C%20premium%20tiles%2C%20modern%20fixtures%2C%20elegant%20design&width=800&height=600&seq=r3b&orientation=landscape',
    ],
    amenities: ['Wifi 100Mbps', 'Điều hòa', 'Tủ lạnh', 'Máy giặt', 'Bếp từ', 'View thành phố'],
    description: 'Phòng Deluxe sang trọng tầng cao, view thành phố tuyệt đẹp, nội thất cao cấp.',
    featured: true,
  },
  {
    id: '4',
    name: 'Phòng Economy D4',
    type: 'economy',
    price: 2800000,
    area: 20,
    floor: 2,
    status: 'available',
    rating: 4.5,
    reviewCount: 67,
    images: [
      'https://readdy.ai/api/search-image?query=cozy%20economy%20apartment%20room%2C%20clean%20simple%20design%2C%20single%20bed%2C%20desk%2C%20wardrobe%2C%20bright%20lighting%2C%20affordable%20rental%20room%20Vietnam&width=800&height=600&seq=r4a&orientation=landscape',
    ],
    amenities: ['Wifi 100Mbps', 'Điều hòa', 'Tủ lạnh', 'Bếp từ'],
    description: 'Phòng tiết kiệm, sạch sẽ, đầy đủ tiện nghi cơ bản, giá cả hợp lý.',
    featured: false,
  },
  {
    id: '5',
    name: 'Phòng Premium E5',
    type: 'premium',
    price: 6500000,
    area: 45,
    floor: 9,
    status: 'booked',
    rating: 5.0,
    reviewCount: 29,
    images: [
      'https://readdy.ai/api/search-image?query=premium%20penthouse%20apartment%20interior%2C%20spacious%20living%20area%2C%20panoramic%20city%20view%2C%20luxury%20furniture%2C%20modern%20design%2C%20high%20floor%20apartment%20Vietnam&width=800&height=600&seq=r5a&orientation=landscape',
    ],
    amenities: ['Wifi 100Mbps', 'Điều hòa', 'Tủ lạnh', 'Máy giặt', 'Bếp từ', 'Penthouse', 'Sân thượng'],
    description: 'Căn hộ Premium tầng thượng, không gian rộng rãi, view 360 độ toàn thành phố.',
    featured: true,
  },
  {
    id: '6',
    name: 'Phòng Studio F6',
    type: 'studio',
    price: 3200000,
    area: 22,
    floor: 4,
    status: 'available',
    rating: 4.6,
    reviewCount: 33,
    images: [
      'https://readdy.ai/api/search-image?query=compact%20studio%20apartment%20with%20smart%20storage%20solutions%2C%20modern%20minimalist%20design%2C%20Murphy%20bed%2C%20multifunctional%20furniture%2C%20bright%20colors%2C%20Vietnam%20rental&width=800&height=600&seq=r6a&orientation=landscape',
    ],
    amenities: ['Wifi 100Mbps', 'Điều hòa', 'Tủ lạnh', 'Bếp từ'],
    description: 'Studio thông minh với thiết kế tối ưu không gian, đầy đủ tiện nghi.',
    featured: false,
  },
];

export const roomTypes = [
  { value: 'all', label: 'Tất cả loại phòng' },
  { value: 'studio', label: 'Studio' },
  { value: '1bedroom', label: '1 Phòng ngủ' },
  { value: 'deluxe', label: 'Deluxe' },
  { value: 'premium', label: 'Premium' },
  { value: 'economy', label: 'Economy' },
];

export const priceRanges = [
  { value: 'all', label: 'Tất cả mức giá' },
  { value: '0-3000000', label: 'Dưới 3 triệu' },
  { value: '3000000-5000000', label: '3 - 5 triệu' },
  { value: '5000000-999999999', label: 'Trên 5 triệu' },
];
